import { isHttpError } from '@wix/cli-http-client';

interface ErrorResults {
  results?: Array<{ componentId?: string; error?: string }>;
}

export function isTrustedInternalErr(e: unknown) {
  if (isHttpError(e)) {
    const appError = e.response?.data?.details?.applicationError as
      | { description?: string }
      | undefined;

    if (appError?.description) {
      let errDescription: ErrorResults | undefined;

      try {
        errDescription = JSON.parse(appError.description) as ErrorResults;
      } catch {
        // ignore
      }

      return errDescription?.results?.some((result) =>
        result.error?.startsWith('scriptAsset is not supported')
      );
    }
  }

  return false;
}
